import {
    RECEIVE_SERP_URL_DOMAIN,
    RECEIVE_REFINEMENTS,
    RECEIVE_KEYWORDS,
    RECEIVE_ARRIVAL_DATE,
    RECEIVE_DEPARTURE_DATE,
    REDIRECT,
    SHOW_DATES_POPUP,
    HIDE_DATES_POPUP,
    UPDATE_SEARCH
} from '../actions/action-types';


export default function search(state = {}, action) {
    switch (action.type) {
        case UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload
            };
        case RECEIVE_SERP_URL_DOMAIN:
            return {
                ...state,
                serpUrlDomain: action.domain
            };

        case RECEIVE_REFINEMENTS:
            return {
                ...state,
                refinements: {
                    ...state.refinements,
                    ...action.refinements
                }
            };

        case RECEIVE_KEYWORDS:
            return {
                ...state,
                keywords: action.keywords
            };

        case RECEIVE_ARRIVAL_DATE:
            return {
                ...state,
                arrivalDate: action.date
            };

        case RECEIVE_DEPARTURE_DATE:
            return {
                ...state,
                departureDate: action.date
            };

        case REDIRECT:
            setTimeout(() => {
                window.location = action.url;
            }, 0);
            return state;

        case HIDE_DATES_POPUP:
            return {
                ...state,
                dateModalSerpParams: null,
                isLoadingSerp: false,
                showDatesModal: false,
                thumbnailUrl: null
            };

        case SHOW_DATES_POPUP:
            return {
                ...state,
                ...action.payload,
                showDatesModal: true
            };

        default:
            return state;
    }
}
